import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { whatsappUrl } from "../siteConfig";

const WhatsAppButton = () => {
  return (
    <a
      href={whatsappUrl()}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with Recon Calibration on WhatsApp"
      className="fixed bottom-24 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition hover:scale-105 hover:bg-[#20ba5a]"
    >
      <FaWhatsapp size={30} />
    </a>
  );
};

export default WhatsAppButton;
